import { APIClient, IAPIClient } from '@askporter/api-client';
import { getAPIAuthToken } from '@askporter/auth-provider';

export const API = (): IAPIClient => APIClient({ getAPIAuthToken });
